(() => {
  const initSlider = () => {
    const collectionListSwiper = document.querySelector(
      ".collection-list__swiper"
    );
    const pagination = document.querySelector(
      ".collection-list__swiper-pagination"
    );

    if (collectionListSwiper) {
      let swiperParams = {
        slidesPerView: 2.5,
        spaceBetween: 12,
        draggable: true,
        breakpoints: {
          768: {
            slidesPerView: "auto",
            spaceBetween: 16,
          },
        },
        pagination: {
          el: pagination,
          type: "bullets",
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
        navigation: {
          nextEl: '.collection-list__inner .scroll-slider-nav-button--next',
          prevEl: '.collection-list__inner .scroll-slider-nav-button--prev',
        }
      };

      const listSwiper = new Swiper(collectionListSwiper, swiperParams);
    }
  };

  // Initial call
  document.addEventListener("DOMContentLoaded", initSlider);

  // Re-init on section load
  document.addEventListener("shopify:section:load", function (section) {
    initSlider(section.target);
  });
})();
